import { CommonModule, DatePipe } from '@angular/common';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { ArraySplitterPipe } from './pipes/array-splitter.pipe';
import { EllapseDatePipe } from './pipes/ellapse-date.pipe';
import { SafeHtmlPipe } from './pipes/safehtml.pipe';
// Don't use index.ts here
import { GravatarPipe } from './pipes/gravatar.pipe';
import { PcntPipe } from './pipes/pcnt.pipe';
import { TypeofPipe } from './pipes/typeof.pipe';
import { BlockScrollDirective } from './directives/block-scroll.directive';
import { TipDirective } from './directives/tip.directive';
import { PortalModule } from '@angular/cdk/portal';
import {
  DATE_FORMAT,
  defaultDateFormat,
  defaultPcntFormat,
  PCNT_FORMAT,
} from './models/data-format';
import { AdEllipsisDirective } from './directives/ellipsis.directive';
import { AdReadOnlyDirective } from './directives/adReadonly.directive';


@NgModule({
  declarations: [
    GravatarPipe,
    EllapseDatePipe,
    SafeHtmlPipe,
    ArraySplitterPipe,
    PcntPipe,
    TypeofPipe,
    BlockScrollDirective,
    TipDirective,
    AdEllipsisDirective,
    AdReadOnlyDirective,
  ],
  imports: [CommonModule, PortalModule],
  providers: [
    DatePipe,
    // , { provide: DATE_FORMAT, useValue: defaultDateFormat }
    // , { provide: PCNT_FORMAT, useValue: defaultPcntFormat }  // if inject DATE_FORMAT and PCNT_FORMAT here, it will override the forRoot
  ],
  exports: [
    GravatarPipe,
    EllapseDatePipe,
    SafeHtmlPipe,
    ArraySplitterPipe,
    PcntPipe,
    TypeofPipe,
    BlockScrollDirective,
    TipDirective,
    AdEllipsisDirective,
    AdReadOnlyDirective,
  ],
})
export class ADSharedModule {
  static forRoot(
    providers: Provider[] = null
  ): ModuleWithProviders<ADSharedModule> {
    return {
      ngModule: ADSharedModule,
      providers: providers,
      // || [
      //   { provide: DATE_FORMAT, useValue: defaultDateFormat },
      //   { provide: PCNT_FORMAT, useValue: defaultPcntFormat }
      // ]
    };
  }
  static forChild(providers: Provider[]): ModuleWithProviders<ADSharedModule> {
    return {
      ngModule: ADSharedModule,
      providers,
    };
  }
}
